<h2 mat-dialog-title class="dialog-title" mat-dialog-draggable-title>
    {{ dialogTitle }}
    <button type="button" class="close" aria-label="Close" (click)="onCancel()">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  <mat-divider></mat-divider>
  
  <div class="sms-event-dialog">
  
    <!-- Tìm kiếm -->
    <div class="search-section">
      <form (ngSubmit)="onSearch()" #searchForm="ngForm">
        <div class="row" style="margin-top: 10px;">
          <!-- Tên nghiệp vụ -->
          <div class="col-lg-4 col-md-6">
            <mat-form-field class="w-100">
              <input type="text" matInput
                  [placeholder]="'search_form.business_name' | translate"
                  name="searchBusinessName"
                  [(ngModel)]="searchBusinessName"
                  (blur)="trimSearchBusinessName()" autocomplete="off">
            </mat-form-field>
          </div>
  
          <!-- Nội dung SMS -->
          <div class="col-lg-4 col-md-6">
            <mat-form-field class="w-100">
              <input type="text" matInput
                  [placeholder]="'search_form.sms_content' | translate"
                  name="searchSmsContent"
                  [(ngModel)]="searchSmsContent"
                  (blur)="trimSearchSmsContent()" autocomplete="off">
            </mat-form-field>
          </div>
  
          <!-- button tìm kiếm -->
          <div class="col-lg-4 col-md-6 d-flex align-items-center justify-content-end">
            <button mat-stroked-button color="primary" type="submit">
              <mat-icon class="mr-0">search</mat-icon>
              {{'enterprise_contract.buttons.search' | translate}}
            </button>
          </div>
        </div>
      </form>
    </div>
  
    <!-- Bảng dữ liệu -->
    <div class="mat-table-container table-container" style="min-height: 100px !important;">
      <mat-table [dataSource]="dataSource" class="mat-table" style="border-right: 1px solid #CBCBCB;">
        <!-- STT -->
        <ng-container matColumnDef="stt">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom" style="flex: 0 0 5%; max-width: 5%;">
            {{'enterprise_contract.table_headers.No' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom" style="flex: 0 0 5%; max-width: 5%;"
                (click)="$event.stopPropagation()">
            {{(paginate.currentPage * paginate.pageSize) + displayedRows.indexOf(element) + 1}}
          </mat-cell>
        </ng-container>
  
        <!-- Tên nghiệp vụ -->
        <ng-container matColumnDef="businessName">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="flex: 0 0 25%; max-width: 25%;">
            {{'search_form.business_name' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="flex: 0 0 25%; max-width: 25%;">
            <span class="fix-width" [matTooltip]="element.businessName">{{ element.businessName }}</span>
          </mat-cell>
        </ng-container>
  
        <!-- Nội dung SMS -->
        <ng-container matColumnDef="smsContent">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="flex: 0 0 40%; max-width: 40%;">
            {{'search_form.sms_content' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="flex: 0 0 40%; max-width: 40%;">
            <span class="fix-width" [matTooltip]="element.smsContent">{{ element.smsContent }}</span>
          </mat-cell>
        </ng-container>
  
        <!-- Đối tượng gửi -->
        <ng-container matColumnDef="sendTarget">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="flex: 0 0 12%; max-width: 12%;">
            {{'search_form.send_target' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center" style="flex: 0 0 12%; max-width: 12%;">
            <span class="fix-width">{{ element.sendTarget }}</span>
          </mat-cell>
        </ng-container>
  
        <!-- Lựa chọn gửi SMS -->
        <ng-container matColumnDef="select">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom select-header" style="flex: 0 0 18%; max-width: 18%;">
            {{'service_type.remind_configuration.select_event_sms' | translate}}
            <mat-checkbox style="margin-top: 5px;" class="ml-2" [(ngModel)]="isSelectAll" (change)="toggleSelectAll()" color="primary"></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" class="mat-header-cell-center number-cell-center mat-cell-non-boder-right-bottom"
          style="flex: 0 0 18%; max-width: 18%;"
                (click)="$event.stopPropagation()">
            <mat-checkbox color="primary" [(ngModel)]="element.selected" (change)="onRowCheckChange(element)"></mat-checkbox>
          </mat-cell>
        </ng-container>
  
        <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></mat-row>
  
      </mat-table>
      
        <div *ngIf="!displayedRows?.length" class="text-center p-3">
            Không có nghiệp vụ gửi tin phù hợp
        </div>
    </div>
  
    <!-- Phân trang: chỉ hiển thị khi có dữ liệu -->
    <app-pagination *ngIf="paginate.totalRow > 0" [(paginate)]="paginate" (pageChange)="onChangePage($event)"></app-pagination>
  
    <!-- Footer -->
    <mat-dialog-actions class="mt-2 mat-dialog-actions-custom" style="display: flex !important;">
      <button mat-stroked-button color="primary" type="button" class="mr-3 mb-1" (click)="onCancel()">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button type="button" color="primary" class="mb-1"
            (click)="onSave()">
        <mat-icon class="mr-0">save</mat-icon>
        {{'button.save' | translate}}
      </button>
    </mat-dialog-actions>
  
  </div>